<template>
  <a-modal :title="modal.title" v-model="modal.visible" @cancel="handleCancel" :width="900">
    <div style="display:flex;margin-bottom:20px">
      <a-input v-model="dataName" placeholder="请输入模版名称" />
      <a-input v-model="remarkName" placeholder="请输入备注" />
      <a-button @click="onSearch" style="margin-left:10px" type="primary">查询</a-button>
      <a-button @click="onCancel" style="margin-left:10px" type="primary">清除</a-button>
    </div>
    <a-table
      class="origin-style ant-info-table"
      :rowKey="(record, index)=>{return record.materialTemplateId}"
      :loading="loading"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :columns="tableColumns"
      :data-source="dataSource"
    />
    <template slot="footer">
      <a-button @click="handleOk" type="primary">保存</a-button>
    </template>
  </a-modal>
</template>

<script>
import { toolMixin } from '@/utils/mixin'
export default {
  mixins: [toolMixin],
  data() {
    return {
      modal: {
        visible: false,
        form: this.$form.createForm(this),
        title: '选择模版',
        data: {},
      },
      loading: false,
      dataName: '',
      remarkName: '',
      productType: null,
      tableColumns: [
        {
          title: '序号',
          customRender: (text, row, index) => {
            return <span>{index + 1}</span>
          },
        },
        {
          title: '模版名称',
          dataIndex: 'materialTemplateName',
        },
        {
          title: '模版名称',
          dataIndex: 'templateRemark',
        },
        {
          title: '添加时间',
          dataIndex: 'createTime',
        },
      ],
      dataSource: [],
      selectedRowKeys: [],
      rowKey: 'materialTemplateId',
    }
  },
  methods: {
    onCancel() {
      this.dataName = ''
      this.remarkName = ''
      this.getAreaList(this.productType)
    },
    async onSearch() {
      this.loading = true
      const res = await this.$axios.post('/visa/admin/productMaterialTemplate/queryTemplateByProductType', {
        data: {
          productType: this.productType,
        },
      })
      // this.dataSource = res.data
      let filterList = null
      filterList =
        res.data && res.data.length
          ? res.data.filter(item => {
              return item.materialTemplateName.indexOf(this.dataName) !== -1 // 这里是根据name进行模糊查询
            })
          : []
      this.dataSource = filterList
      if (this.remarkName) {
        filterList =
          this.dataSource && this.dataSource.length
            ? this.dataSource.filter(item => {
                return item.templateRemark.indexOf(this.remarkName) !== -1 // 这里是根据name进行模糊查询
              })
            : []
      }
      this.dataSource = filterList
      this.loading = false
    },
    onSelectChange(selectedRowKeys, row) {
      this.selectedRowKeys = selectedRowKeys
    },
    async start({ productType, selectedRowKeys = [] } = {}) {
      console.log('是一个么', selectedRowKeys)
      this.resetModal$t()
      await this.getAreaList(productType)
      this.productType = productType
      this.selectedRowKeys = selectedRowKeys
      this.modal.visible = true
      return new Promise((resolve, reject) => {
        this.$once('end', function(state, result) {
          if (state === 'ok') {
            resolve(result)
          }
          if (state === 'cancel') {
            reject(new Error('E_CANCEL'))
          }
          this.modal.visible = false
        })
      })
    },
    async getAreaList(productType) {
      const res = await this.$axios.post('/visa/admin/productMaterialTemplate/queryTemplateByProductType', {
        data: { productType },
      })
      this.dataSource = res.data
    },
    async handleOk() {
      const list = []
      console.log('selectedRowKeys', this.selectedRowKeys)
      
      this.dataSource.map(row => {
        if (this.selectedRowKeys.includes(row[this.rowKey])) {
          list.push(row)
        }
      })
      console.log('nishayisi ', list)
      this.$emit('end', 'ok', list)
    },
    handleCancel() {
      this.$emit('end', 'cancel')
    },
  },
}
</script>

<style></style>
